import httpConfig from './config'
import ApiConfig from './groupConfig'
import { joinParams, removeAllLocalStorages, handleParams } from '../utils'
import Axios from 'axios'
import pathToRegexp from 'path-to-regexp';

import order from './order'
import roomType from './roomType'
import Report from './report'
import Clean from './clean'
import baseSetting from './basesetting'
import rule from './rule'
import delegate from './delegate'

import { notification } from 'antd'
import moment from 'moment'


const axiosInstance = Axios.create({
  headers: {
    'X-Ca-Stage': httpConfig.XCaStage,
    'X-Client-Type': 6
  }
})
let pending = []
let cancelToken = Axios.CancelToken
let removePending = (config) => {
  for(let p in pending){
    if(pending[p].u === config.url + '&' + config.method) {
      pending[p].f()
      pending.splice(p, 1)
    }
  }
}

/*--------    拦截器 start    --------*/
axiosInstance.interceptors.request.use(async function (config) {
  removePending(config)
  let url_params = config.url_params
  config.cancelToken = new cancelToken((c)=>{
    pending.push({ u: config.url + '&' + config.method, f: c })
  })
  let xmsToken = window.localStorage.getItem('token')
  if (xmsToken) config.headers['Authorization']= xmsToken

  let omsToken = window.localStorage.getItem('oms-token')
  if (omsToken && (config.url === '/api/oms/changePassword' || config.url === '/api/oms/logout')) {
    config.headers['Right'] = omsToken
  }

  // const xuser = window.localStorage.getItem('XBEDUSER')
  //x-xbed-user 为yuguohua的时候是切换测试服务器qa 为''使用默认测试服务器test
  // if(httpConfig.XCaStage === 'TEST')
  //   config.headers['x-xbed-user'] = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(xuser))
  
  // if (config.url === '/api/gateway_auth/login' || config.url === '/api/oms/logout') {
    //登录接口 / 登出接口
  // config.headers['X-Client-Type'] = 6
  // }
    
  config.baseURL = ApiConfig[config.url] ? ApiConfig[config.url] : httpConfig.cleanUrl
  // 动态路径替换（暂时只支持get/post/delete）
  if(config.method === "post"){
    url_params = config.data.url_params
    delete config.data.url_params
  }
  if(url_params){
    config.url = pathToRegexp.compile(config.url)(url_params);
  }
  return config
}, error => {
  notification.error({
    message: '请求超时，请重试'
  })
  return Promise.reject(error)
})

axiosInstance.interceptors.response.use(async function (response) {
  removePending(response.config)
  
  return response.data
}, error => {
  let response = JSON.parse(JSON.stringify(error)).response
  if (!!response) {
    notification.error({
      message: (response && response.status) === 404 ? '网络异常请重试' : (response.data && response.data.msg) || '接口请求错误'
    })
  }
  if(response && (response.status === 401 || response.status === 450 || (response.status === 403 && response.headers["x-ca-error-code"] === "A403JE"))) {
    removeAllLocalStorages()
    let ref = `${window.location.protocol}//${window.location.host}/login`
    window.location.href === ref || (window.location.href = ref)
  }

  return Promise.reject(error)
})
/*--------    拦截器 end    --------*/

export default {
  instance: axiosInstance,
  ...order,
  ...roomType,
  ...Report,
  ...Clean,
  ...baseSetting,
  ...rule,
  ...delegate,

  /**
   * 登陆阿里云授权
   * @param {*} userName 
   * @param {*} password 
   * @param {*} type xms oms
   */
  login(userName, password, type) {
    
    return this.instance.post('/api/gateway_auth/login', joinParams({
      username: userName,
      password: password,
      type: type
    }))
  },

  /**
   * 退出登录
   * @param {*} userName 用户名 
   */
  logout(params) {
    return this.instance.post('/api/oms/logout', joinParams(params))
  },

  /**
   * 获取七牛上传文件token
   * @param {+} isPrivate 0 公有 1私有 
   * @param {+} source 上传来源 
   */
  getUploadQiniuToken(params) {
    return this.instance.post('/api/QiNiu/upload/getToken', joinParams(params))
  },

  /**
   * 上传图片到七牛
   * @param {+} file 
   * @param {+} upToken 
   */
  uploadImgToQiNiu(file, upToken, remark = '用户证件照', isPrivate = 1) {
    return Axios({
      method: 'post',
      url: 'https://upload.qiniup.com',
      data: {},
      transformRequest: function (data) {
        var formData = new FormData()
        formData.append('token', upToken)
        formData.append('file', file)
        formData.append('x:fileDirId', -1)
        formData.append('x:isPrivate', isPrivate)
        formData.append('x:remark', remark)
        return formData
      }
    })
  },

  /**
   * 门店列表
   * @param {*} current_page 
   * @param {*} per_page 
   */
  getHotelLists(params) {
    return this.instance.get('/api/v1/chains/my', {
      params: params
    })
  },

  /**
   * 修改密码
   * @param {+} userName 用户名
   * @param {+} newPassWord 新密码  md5加密
   * @param {+} orgPassWord 旧密码  md5加密
   */
  updatePassword(params) {

    // return Axios({
    //   method: 'post',
    //   url: `${httpConfig.gateUrl}/api/test/oms/changePassword`,
    //   data: joinParams(params),
    //   headers: {
    //     Right: omsToken
    //   }
    // })
    return this.instance.post('/api/oms/changePassword', joinParams(params))
  },

  /**
   * 获取订单消息通知列表
   * @param {*} page 页码 
   * @param {*} size 每页数 
   * @param {*} hotel_ids 门店id, 多个门店以英式逗号分开
   * @param {*} remind_type 通知类型, {2: "未通知, 默认", 1: "已通知", 0: "全部"}
   */
  getOrderNotifications(params) {
    return this.instance.get('/xms/api/v0/xbed_order_message/remind_messages', {
      params: handleParams(params)
    })
  },

  /**
   * 公告列表
   * @param {+} userId
   */
  getNotices(params) {
    return this.instance.get('/api/notice/xmsNewlist', {
      params: params
    })
  },

  /**
   * 读取公告详情
   * @param {+} userId
   * @param {+} userName
   * @param {+} noticeId
   */
  getNoticeDetail(params) {
    return this.instance.get('/api/notice/xmsNoticeRead', {
      params: params
    })
  },

  /**
   * 导出文件
   * @param {string} url 接口 
   * @param {object} _params 参数 
   * @param {string} fileName 文件名
   * @param {string} ext 文件后缀
   * @url_params {string} url_params url补充参数
   */
  exportFile(url, _params, fileName = null, ext = 'xls', url_params = "") {
    
    return new Promise((resolve, reject) => {
      let params = ''
      if(_params){
        params = "?"
        Object.keys(_params).forEach((key, i) => {
          params = `${params}${i !== 0 ? '&' : ''}${key}=${encodeURIComponent(_params[key])}`
        })
      }

      let headers = {
        'X-Ca-Stage': httpConfig.XCaStage,
        'Authorization': window.localStorage.getItem('token'),
      }
      let path_url = `${ApiConfig[url]}${url}${url_params}${params}`

      Axios({
        method: 'get',
        url: path_url,
        responseType: 'blob',
        headers: headers
      }).then((response) => {
        if(fileName){
          fileName = `${fileName}${moment().format('YYYYMMDDHHmmss')}`
        }
        if (!ext || !fileName){
          let disposition = response.headers['content-disposition']
          let disIndex = disposition.indexOf('.')
          let nameIndex = disposition.indexOf('=')

          if (disIndex > -1) {
            ext = disposition.substring(disIndex+1, disposition.length)
          }
          if (nameIndex > -1){
            fileName = decodeURIComponent(disposition.substring(nameIndex + 1, disIndex))
          }
        }

        let expFileName = `${fileName}.${ext}`
        let dataType = response.data.type || 'application/vnd.ms-excel'
        let file = new Blob([response.data], {type: dataType})
        if('msSaveOrOpenBlob' in navigator){
          //兼容IE
          window.navigator.msSaveOrOpenBlob(file, expFileName)
        }
        else {
          //非IE
          let url = window.URL.createObjectURL(file)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', expFileName)
          document.body.appendChild(link)
          link.click()
        }
        resolve()
      }).catch((err) => {
        reject()
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/index.js